import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-form" }
const _hoisted_2 = { class: "layout-form-body" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "content-information" }
const _hoisted_5 = { class: "content-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "layout-form-header" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["LandingFormDetails"], {
            title: $setup.landingFormData.title,
            features: $setup.isDesktop ? $setup.landingFormData.features : $setup.landingFormData.featuresMobile,
            isSignUpView: $setup.props.type !== $setup.PlansFormEnum.WAITLIST
          }, null, 8, ["title", "features", "isSignUpView"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!$setup.formSubmitted)
            ? (_openBlock(), _createBlock($setup["LandingForm"], {
                key: 0,
                isSignUpView: $setup.props.type !== $setup.PlansFormEnum.WAITLIST,
                onSubmit: $setup.handleFormSubmit,
                onSignIn: $setup.onLogin
              }, null, 8, ["isSignUpView"]))
            : (_openBlock(), _createBlock($setup["LandingSuccessForm"], {
                key: 1,
                textData: $setup.landingFormSuccessData,
                onSignIn: $setup.onLogin
              }, null, 8, ["textData"]))
        ])
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "layout-form-footer" }, null, -1))
  ]))
}